import branchManagementLocationsComponent from './locations.component';
import PrintLocationModule from './print';

let branchManagementLocationsModule = angular.module('branchManagementLocationsHistoryHolds', [PrintLocationModule])
  .component('branchManagementLocationsHistoryHolds', branchManagementLocationsComponent)
  .name;

export default branchManagementLocationsModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/locations/index.js